import { ReportState } from './report-reducer';
import { CallConfigAndShopListAction, REPORT_ACTION_TYPE, ReportActions } from './report-type';

export const reportCreators = {
  setReportState: <KeyName extends keyof ReportState>(key: KeyName, value: ReportState[KeyName])
    : ReportActions => ({
      type: REPORT_ACTION_TYPE.SET_REPORT_STATE,
      payload: { key, value }
    }),
  callConfigAndShopList: (onSuccess: () => void, onFailureCallback: () => void): CallConfigAndShopListAction => ({
    type: REPORT_ACTION_TYPE.CALL_CONFIG_AND_SHOP_LIST,
    payload: { onSuccess, onFailureCallback }
  })
};
